import i18next from 'i18next';

const getLanguage = () => i18next.language || window.localStorage.i18nextLng;

/**
 * Resolves a key from the `errors` object of the active locale bundle.
 *
 * The app registers each locale file under the i18next namespace "common"
 * (see src/index.tsx: `resources: { [lang]: { common: <json> } }`), and every
 * locale file has a TOP-LEVEL `errors` object (not nested under a `common`
 * key inside the JSON itself - that nested `common` key only holds
 * `tryAgain`). `i18next.getDataByLanguage(lang)` therefore returns
 * `{ common: <full json> }`, so the errors live at `bundle.common.errors`.
 *
 * This helper is the single place that understands that shape, with
 * defensive fallbacks in case the namespace registration ever changes (e.g.
 * to the default "translation" namespace, or a flat resource without a
 * namespace wrapper).
 */
export function getErrorMessage(key: string): string | undefined {
  const bundle = i18next.getDataByLanguage(getLanguage()) as any;
  const errors = bundle?.common?.errors ?? bundle?.translation?.errors ?? bundle?.errors;
  return errors?.[key];
}
